import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const dataModuleActions = createDataModuleActions('GATE_CARD_ACCOUNT');
export const gateCardAccount = dataModuleActions.dataRequest;
export const gateCardAccountSuccess = dataModuleActions.dataSuccess;
export const gateCardAccountError = dataModuleActions.dataError;
export const resetGateCardAccount = dataModuleActions.dataReset;
